import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpContextToken,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SnackbarService } from '../_services/snackbar.service';
import { map, catchError, throwError } from 'rxjs';
import { LoaderService } from '../_components/loader/loader.service';
import { HelperService } from '../_services/helper.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  delay = true;
  toastNumber = 0;
  CACHE_IT = new HttpContextToken<boolean>(() => false);
  requestTime!: number;

  constructor(
    private snackBar: SnackbarService,
    private loader: LoaderService,
    private helperService: HelperService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const methodInfo = this.getMethodInfo(req.method);
    const apiName = req.headers.get('apiName') || req.url;
    const message = methodInfo.action + apiName;

    this.showInitialSnackBar(message, methodInfo.iconPath);
    this.clearGWTSessionCookies();

    let clonedRequest = this.attachAuthHeaders(req);
    clonedRequest = this.attachContentType(clonedRequest);
    console.log(req);
    console.log(req.method);
    console.log(req.url.includes('/app/fulfillment'));
    // if (!(req.method === "PUT" && (req.url.includes("/app/fulfillment") ||  req.url.includes("/app/extraInfoService")))) {
    //   clonedRequest = this.cleanRequest(clonedRequest);
    // }

    return next.handle(clonedRequest).pipe(
      map((res) => {
        if (res instanceof HttpResponse) {
          this.snackBar.closeSnackBar(message);
        }
        return res;
      }),
      catchError((error: HttpErrorResponse) => {
        this.snackBar.closeSnackBar(message);
        this.handleError(error, apiName, req.headers.get('skipError') === 'true');
        return throwError(() => error);
      }),
    );
  }

  // private cleanRequest(req: HttpRequest<any>): HttpRequest<any> {
  //   let cleanedReq = req;

  //   // ✅ Clean body
  //   if (req.body) {
  //     const cleanedBody = this.helperService.removeNullUndefinedProperties({ ...req.body });
  //     cleanedReq = cleanedReq.clone({ body: cleanedBody });
  //   }

  //   if (req.params && req.params.keys().length > 0) {
  //     const cleanedParams: Record<string, any> = {};
  //     req.params.keys().forEach((key) => {
  //       let val = req.params.get(key);

  //       if (val !== null && val !== undefined && val !== "") {
  //         if (this.isJsonString(val)) {
  //           try {
  //             const parsed = JSON.parse(val);
  //             console.log(parsed)
  //             const clean= this.helperService.removeNullUndefinedProperties(parsed)
  //             console.log(clean)
  //             val = JSON.stringify(this.helperService.removeNullUndefinedProperties(clean));
  //           } catch {}
  //         }
  //         if (val !== "" && val !== null && val !== undefined) {
  //           cleanedParams[key] = val;
  //         }
  //       }
  //     });

  //     cleanedReq = cleanedReq.clone({ setParams: cleanedParams });
  //   }

  //   return cleanedReq;
  // }

  // private isJsonString(val: string): boolean {
  //   return (
  //     (val.startsWith("{") && val.endsWith("}")) ||
  //     (val.startsWith("[") && val.endsWith("]"))
  //   );
  // }
  private getMethodInfo(method: string): { action: string; iconPath: string } {
    switch (method) {
      case 'GET':
        return { action: 'Fetching ', iconPath: '/assets/icons/toaster/fetch_data.svg' };
      case 'PUT':
        return { action: 'Updating ', iconPath: '/assets/icons/toaster/update_data.svg' };
      case 'POST':
        return { action: 'Generating ', iconPath: '/assets/icons/toaster/insert_data.svg' };
      case 'DELETE':
        return { action: 'Deleting ', iconPath: '/assets/icons/toaster/delete_data.svg' };
      default:
        return { action: '', iconPath: '' };
    }
  }

  private showInitialSnackBar(message: string, icon: string): void {
    this.requestTime = Date.now();
    this.snackBar.openSnackBar(message, this.delay, icon);
    this.delay = false;
  }

  private clearGWTSessionCookies(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie.split('; ').forEach((cookie) => {
        const [name] = cookie.split('=');
        if (name.includes('_GWT')) {
          document.cookie = `${name}=; Max-Age=0; path=/;`;
        }
      });
    }
  }

  private attachAuthHeaders(req: HttpRequest<any>): HttpRequest<any> {
    const token = this.helperService.getCookie('auth-token');
    const user = this.helperService.getCookie('auth-user');
    const identifier = this.helperService.getCookie('auth-identifier');

    return req.clone({
      headers: req.headers
        .set('auth-token', token)
        .set('auth-user', user)
        .set('auth-identifier', identifier),
    });
  }

  private attachContentType(req: HttpRequest<any>): HttpRequest<any> {
    const isWrite = req.method === 'POST' || req.method === 'PUT';
    if (isWrite && !req.headers.has('Content-Type')) {
      return req.clone({
        headers: req.headers.set('Content-Type', 'application/json;charset=UTF-8'),
      });
    }
    return req;
  }

  private handleError(error: HttpErrorResponse, apiName: string, skipError: boolean | null): void {
    let errorMsg: string;
    if (error.error instanceof ErrorEvent) {
      errorMsg = `Error - ${error.error.message}`;
    } else {
      errorMsg = `Error - ${error.status}`;
    }

    const fullMessage = `${errorMsg} in ${apiName}`;

    if (fullMessage !== 'Error - 400 in profile' && !skipError) {
      this.snackBar.openErrorSnackBar(fullMessage, 'http');
    }

    this.loader.showLoader(false);
    this.loader.showItemLoader(false);
  }
}
